import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import ForgotPassword from "./pages/ForgotPassword";
import UserDashboard from "./pages/UserDashboard";
import MyReports from "./pages/MyReports";
import OfficerDashboard from "./pages/OfficerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PendingApproval from "./pages/PendingApproval";
import OfficerRegistration from "./pages/OfficerRegistration";

function AppRouter() {
    const location = useLocation();
    
    // Check URL fragment for session_id - handle OAuth callback
    if (location.hash?.includes('session_id=')) {
        return <AuthCallback />;
    }
    
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Landing />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/officerregistration" element={<OfficerRegistration />} />
            
            {/* User Dashboard */}
            <Route 
                path="/dashboard" 
                element={
                    <ProtectedRoute allowedRoles={['user', 'officer', 'admin']}>
                        <UserDashboard />
                    </ProtectedRoute>
                } 
            />
            
            {/* My Reports */}
            <Route 
                path="/reports" 
                element={
                    <ProtectedRoute allowedRoles={['user', 'officer', 'admin']}>
                        <MyReports />
                    </ProtectedRoute>
                } 
            />
            
            {/* Officer Dashboard */}
            <Route 
                path="/officer" 
                element={
                    <ProtectedRoute allowedRoles={['officer', 'admin']}>
                        <OfficerDashboard />
                    </ProtectedRoute>
                } 
            />
            
            {/* Admin Dashboard */}
            <Route
                path="/admin"
                element={
                    <ProtectedRoute allowedRoles={['admin']}>
                        <AdminDashboard />
                    </ProtectedRoute>
                }
            />

            {/* Officer Pending Approval */}
            <Route
                path="/pending-approval"
                element={
                    <ProtectedRoute allowedRoles={['officer_pending', 'officer_rejected']}>
                        <PendingApproval />
                    </ProtectedRoute>
                }
            />

            {/* Catch all - redirect to public home */}
            <Route path="*" element={<Home />} />
        </Routes>
    );
}

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <AppRouter />
                    <Toaster position="top-right" richColors />
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
